
class base32 {
    encode(input) {
      var encoder = new Encoder();
      var output = encoder.update(input, true);
      return output;
    }
    decode (input) {
      var decoder = new Decoder()
      var output = decoder.update(input, true)
      return output
    }
  }
  
  class Encoder {
    constructor() {
      this.skip = 0; // how many bits we will skip from the first byte
      this.bits = 0; // 5 high bits, carry from one byte to the next
      this.output = "";
      this.alphabet = '0123456789abcdefghjkmnpqrtuvwxyz';
    }
    readByte(byte) {
      // coerce the byte to an int
      if (typeof byte === "string") byte = byte.charCodeAt(0);
  
      if (this.skip < 0) {
        // we have a carry from the previous byte
        this.bits |= byte >> -this.skip;
      } else {
        // no carry
        this.bits = (byte << this.skip) & 248;
      }
  
      if (this.skip > 3) {
        // not enough data to produce a character, get us another one
        this.skip -= 8;
        return 1;
      }
  
      if (this.skip < 4) {
        // produce a character
        this.output += this.alphabet[this.bits >> 3];
        this.skip += 5;
      }
  
      return 0;
    }
  
    finish(check) {
      var output =
        this.output + (this.skip < 0 ? this.alphabet[this.bits >> 3] : "") + (check ? "$" : "");
      this.output = "";
      return output;
    }
  
    update(input, flush) {
      for (var i = 0; i < input.length; ) {
        i += this.readByte(input[i]);
      }
      // consume all output
      var output = this.output;
      this.output = "";
      if (flush) {
        output += this.finish();
      }
      return output;
    }
  }
  
  class Decoder {
      constructor(){
          this.skip = 0; // how many bits we will skip from the first byte
          this.byte = 0; // 5 high bits, carry from one byte to the next
          this.output = "";
          this.bits = 0;
          this.alphabet = '0123456789abcdefghjkmnpqrtuvwxyz';
          this.alias = { o:0, i:1, l:1, s:5 }
      }
  
      lookup() {
          var table = {}
          // Invert 'alphabet'
          for (var i = 0; i < this.alphabet.length; i++) {
              table[this.alphabet[i]] = i
          }
          // Splice in 'alias'
          for (var key in this.alias) {
              if (!this.alias.hasOwnProperty(key)) continue
              table[key] = table['' + this.alias[key]]
          }
          this.lookup = function() { return table }
          return table
      }
  
      readChar(char){
          if (typeof char != 'string'){
              if (typeof char === 'number') {
                  char = String.fromCharCode(char)
              }
          }
          char = char.toLowerCase()
          var val = this.lookup()[char]
          if (typeof val === 'undefined') {
              // character does not exist in our lookup table
              return // skip silently. An alternative would be:
              // throw Error('Could not find character "' + char + '" in lookup table.')
          }
          val <<= 3 // move to the high bits
          this.byte |= val >>> this.skip;
          this.skip += 5
          if (this.skip >= 8) {
              // we have enough to preduce output
              this.output += String.fromCharCode(this.byte)
              this.skip -= 8
              if (this.skip > 0) this.byte = (val << (5 - this.skip)) & 255
              else this.byte = 0
          }
      }
  
      finish(check) {
          var output = this.output + (this.skip < 0 ? this.alphabet[this.bits >> 3] : '') + (check ? '$' : '')
          this.output = '';
          return output
      }
  }
  
  export default base32
  